<template>
  <div id="informationDetail">
    <template class="container" v-if="$route.name == 'about-us'">
      <div class="map-container">
        <keep-alive>
          <vue-googlemap :center="center" :zoom="zoom">
            <vue-googlemap-marker :position='center' ref="marker"></vue-googlemap-marker>
            <vue-googlemap-infoWindow :position='center'
                                      draggable :content="content"
                                      style="white-space: pre-line;"
                                      ref='window'></vue-googlemap-infoWindow>
          </vue-googlemap>
        </keep-alive>
      </div>
      <div class="text-center mt-20">
        <el-button type="primary" round @click='show'>{{ $t('footer.show_map') }}</el-button>
      </div>
    </template>
    <div class="row mx-0 pl-5 pr-5" v-if="data">
      <div v-html="data.content"></div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import vueGooglemap from 'vue2-googlemap';
  import { GOOGLE_MAP_KEY } from '@/constants';

  Vue.use(vueGooglemap);

  vueGooglemap.initGooglemap({
    key: GOOGLE_MAP_KEY,
    language: 'zh-HK',
    v: '3',
  });

  export default {
    name: 'InformationDetail',
    data() {
      return {
        data: null,
        zoom: 17,
      };
    },
    computed: {
      center() {
        const { company_address_lat: lat, company_address_lng: lng } = this.$store.state.config;
        return { lat, lng };
      },
      content() {
        return this.$store.state.config.company_address;
      },
    },
    watch: {
      $route: {
        handler(route) {
          const re = new RegExp('-', 'g');
          this.name = route.name.replace(re, '_');
          this.$api.information.get(this.name).then(({ data: response }) => {
            this.data = response.data;
          });
        },
        immediate: true,
      },
    },
    methods: {
      show() {
        this.$refs.window.open(this.$refs.marker.$marker);
      },
    },
  };
</script>

<style lang="scss">
  .map-container {
    height: 500px;
  }
</style>
